export enum EventCalendarView {
  list = 'eventCalendarList',
}

export enum EventCalendarSize {
  full = 'full',
  small = 'small',
}
